import React, { useMemo, useState } from 'react';
import { formatDeviceInfoSummary } from '../utils/deviceInfo';
import './EventTimeline.css';

const ACTION_META = {
  activated: { icon: '✅', label: 'Activate' },
  validated: { icon: '🔄', label: 'Validate' },
  heartbeat: { icon: '💓', label: 'Heartbeat' },
  extended: { icon: '🔁', label: 'Renewal' },
  invalid_attempt: { icon: '🔴', label: 'Invalid' },
  unbound: { icon: '🔧', label: 'Unbind' },
  deactivated: { icon: '🚫', label: 'Revoke' },
  status_changed: { icon: '⚙️', label: 'Status' },
  created: { icon: '🎫', label: 'Created' },
};

const FILTER_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'activated', label: 'Activate' },
  { value: 'validated', label: 'Validate' },
  { value: 'heartbeat', label: 'Heartbeat' },
  { value: 'invalid_attempt', label: 'Invalid' },
  { value: 'admin', label: 'Admin actions' },
];

const EventTimeline = ({ events = [] }) => {
  const [filter, setFilter] = useState('all');
  const [expandedId, setExpandedId] = useState(null);

  const filtered = useMemo(() => {
    if (filter === 'all') return events;
    if (filter === 'admin') {
      return events.filter((e) =>
        ['unbound', 'deactivated', 'status_changed', 'extended', 'created'].includes(e.action)
      );
    }
    return events.filter((e) => e.action === filter);
  }, [events, filter]);

  return (
    <div className="event-timeline">
      <div className="event-timeline-filters">
        {FILTER_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            className={`event-filter-btn ${filter === opt.value ? 'active' : ''}`}
            onClick={() => setFilter(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="event-timeline-empty">No events for this filter.</div>
      ) : (
        <div className="event-timeline-list">
          {filtered.map((event) => {
            const meta = ACTION_META[event.action] || { icon: '•', label: event.action };
            const isInvalid = event.action === 'invalid_attempt';
            const expanded = expandedId === event.id;
            const attemptedInfo = event.details?.attempted_device_info;

            return (
              <div
                key={event.id}
                className={`event-row ${isInvalid ? 'event-row-invalid' : ''}`}
              >
                <div className="event-row-main">
                  <span className="event-icon">{meta.icon}</span>
                  <span className={`event-badge event-badge-${event.action}`}>{meta.label}</span>
                  {event.system_name && (
                    <span className="event-system">{event.system_name}</span>
                  )}
                  <span className="event-description">{event.description}</span>
                  <span className="event-time">
                    {new Date(event.timestamp).toLocaleString()}
                  </span>
                </div>
                {isInvalid && attemptedInfo && (
                  <>
                    <button
                      type="button"
                      className="event-expand-btn"
                      onClick={() => setExpandedId(expanded ? null : event.id)}
                    >
                      {expanded ? 'Hide device' : 'Show attempted device'}
                    </button>
                    {expanded && (
                      <pre className="event-device-json">
                        {formatDeviceInfoSummary(attemptedInfo)}
                      </pre>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default EventTimeline;
